module.exports = __webpack_public_path__ + "img/Photo 4 de couv des pigments.bf8dc5bb.jpg";